import { z } from "zod";

import { isoDate } from "./iso-date-schema";
import { jsonSchema } from "./json-schema";
import { vendorItemSchema } from "./vendor-item-schema";

// Enum mimics from your schema — adjust as needed
export const createdOnEnum = z.enum(["SYSTEM", "WEBHOOK"]);
export const userRoleEnum = z.enum([
  "ADMIN",
  "MANAGER",
  "OWNER",
  "TECHNICIAN",
  "EVALUATOR",
  "COORDINATOR",
]);

export const userItemSchema = z.object({
  id: z.string().length(24),
  shortId: z.string().nullable(),
  uuid: z.string().uuid(),
  name: z.string(),
  firstName: z.string(),
  email: z.string(),
  phone: z.string().nullable(),
  invoicedContactId: z.string().nullable(),
  workingHours: jsonSchema,
  isPending: z.boolean(),
  isVerify: z.boolean(),
  isActivated: z.boolean(),
  defaultRoleId: z.string(),
  userCreatedById: z.string(),
  createdOn: createdOnEnum,
  bio: z.string().nullable(),
  jobTitle: z.string().nullable(),
  createdAt: isoDate,
  updatedAt: isoDate,
  roles: z.array(userRoleEnum).nullish(),
  defaultRole: z.string().nullish(),
  avatarUrl: z.string().nullish(),
  accounts: z.array(vendorItemSchema).nullish(),
  userProfiles: z.any().nullish(),
});
